// @flow strict
import React from "react";
import { Link } from "gatsby";
import type { Edge } from "../../../types";
import styles from "./ExternalLink.module.scss";

type Props = {
  edge: Edge,
};

const ExternalLink = ({ edge }: Props) => (
  <div>
    <Link className={styles["external_link__item-readmore"]} to={edge.node.fields.slug}>
      Read
    </Link>
    {edge.node.frontmatter.github ? (
      <Link
        className={styles["external_link__item-readmore"]}
        target="_blank"
        to={edge.node.frontmatter.github}
      >
        Github
      </Link>
    ) : (
      ""
    )}
    {edge.node.frontmatter.paper ? (
      <Link
        className={styles["external_link__item-readmore"]}
        target="_blank"
        to={edge.node.frontmatter.paper}
      >
        Paper
      </Link>
    ) : (
      ""
    )}
  </div>
);

export default ExternalLink;
